import i18n from "@/common/i18n";
/***
 * 图片收集题: 相关配置
 */
// import { nanoid } from 'nanoid';

export default {
  reporType: 100184,
  //中文
  zh: {
    placeholder: `${i18n.t("lang.k_373001")}`,
    uploadTip: `${i18n.t("lang.k_373002")}`
  },
  // 英文
  en: {
    placeholder: 'Please upload the image',
    uploadTip: 'Supported formats: jpg、jpeg、png、bmp. Maximum of 3 images can be uploaded, with each image size not exceeding 4MB'
  },
  // 创建一个隐私协议项
  create(lang = 'zh') {
    return {
      label: `${i18n.t("lang.k_373003")}`,
      subject: `${i18n.t("lang.k_373003")}`,
      required: true,
      //是否必填
      is_must: 1,
      options: {
        placeholder: `${i18n.t("lang.k_373001")}`
      },
      items: [],
      type: 14,
      reporType: this.reporType,
      reqType: 14,
      default_type: 14,
      system_type: 14
    };
  }
};